module.exports = __webpack_public_path__ + "664a857038281fc1a4acf928cd4efd2a.pdf";